import React, { useContext, useEffect, useState } from 'react';

import { DeleteOutline } from '@mui/icons-material';
import AssignmentIcon from '@mui/icons-material/Assignment';
import AssignmentOutlinedIcon from '@mui/icons-material/AssignmentOutlined';
import ChangeHistoryOutlinedIcon from '@mui/icons-material/ChangeHistoryOutlined';
import CheckOutlinedIcon from '@mui/icons-material/CheckOutlined';
import CreateOutlined from '@mui/icons-material/CreateOutlined';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import FavoriteOutlinedIcon from '@mui/icons-material/FavoriteOutlined';
import FavoriteBorderOutlinedIcon from '@mui/icons-material/FavoriteBorderOutlined';
import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined';
import StarBorderOutlinedIcon from '@mui/icons-material/StarBorderOutlined';
import StarOutlinedIcon from '@mui/icons-material/StarOutlined';
import {
  Box,
  Button,
  Card,
  CardContent,
  CardMedia,
  Chip,
  Divider,
  Grid,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Typography
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import noImage from '../../components/assets/noImage.svg';
import halfStar from '../../components/assets/HalfMaskedStar.svg';
import {
  gray10,
  gray100,
  gray70,
  gray80,
  gray90,
  green50,
  pink,
  primary10,
  primaryColor,
  yellow,
  white,
  primaryButtonOutlinedColor,
  tertiaryButtonOutlinedColor,
  green10,
  green100
} from '../../constants/Colors';
import { productStatus } from '../../constants/Enum';
import {
  ProductInfosType,
  VersionType
} from '../../validation/products/productType';
import { EvaluationType } from '../../validation/evaluations/evaluationsType';
import { UserInfoType } from '../../validation/user/userType';

import CustomDialog from './CustomDialog';
import VersionSelect from './VersionSelect';
import DeleteDialog from './CustomDeleteDialog';
import dayjs from 'dayjs';
import { AuthContext } from '../../contexts/auth';

export type ItemProps = ProductInfosType & EvaluationType & UserInfoType;

interface MaterialProps {
  item: ItemProps;
  buttonSection?: React.ReactElement<{ myListFlg: boolean }>;
  buttonSectionType?: string;
  mylistReviewSection: boolean;
  statusSection: boolean;
  addMylistFun?: (productId: number, productName: string) => Promise<void>;
  deleteMylistFun?: (productId: number, productName: string) => Promise<void>;
  addFavoriteFun?: (productId: number, productName: string) => Promise<void>;
  deleteFavoriteFun?: (productId: number, productName: string) => Promise<void>;
  deleteProductFun?: (productId: number) => Promise<void>;
  adminFlg?: boolean;
}

const MaterialCard: React.FC<MaterialProps> = (props) => {
  const {
    item,
    buttonSection,
    buttonSectionType,
    mylistReviewSection,
    statusSection,
    addMylistFun,
    deleteMylistFun,
    addFavoriteFun,
    deleteFavoriteFun,
    deleteProductFun,
    adminFlg
  } = props;
  const checked = 1;

  const navigate = useNavigate();
  const { userId, userType, userRank } = useContext(AuthContext);

  // 事務局ページの判断
  const currentPage = window.location.pathname;
  const [adminPage, setAdminPage] = useState<boolean>(false);
  const [favoritePage, setFavoritePage] = useState<boolean>(false);

  useEffect((): void => {
    setDisplayMyListNumber(item.myListNum);
    setAdminPage(currentPage.includes('operator'));
    setFavoritePage(currentPage.includes('favorite'));
  }, [item.myListNum, currentPage]);

  function statusText(): string {
    switch (item.status) {
      case productStatus.deleted:
        return 'ユーザー削除';
      case productStatus.approved:
        return '承認済';
      case productStatus.draft:
        return '下書き';
      case productStatus.request:
        return '登録申請中';
      case productStatus.changeRequest:
        return '更新申請中';
      case productStatus.pastVersion:
        return '過去バージョン';
      case productStatus.reject:
        return '非承認';
      default:
        return '非承認';
    }
  }

  function badgeColor(): string {
    switch (item.status) {
      case productStatus.approved:
      case productStatus.changeRequest:
        return green50;
      case productStatus.draft:
        return white;
      case productStatus.request:
      case productStatus.reject:
      default:
        return gray80;
    }
  }

  function border(): boolean {
    if (item.status == productStatus.draft) {
      return true;
    }
    return false;
  }
  const statusBadgeBorder = { border: border() ? `1px solid ${gray90}` : '' };

  const favoriteWidth = favoritePage ? '280px' : '200px';

  const styles = {
    addButton: {
      boxSizing: 'border-box',
      height: '44px',
      p: '10px 22px 10px 16px',
      '@media screen and (max-width: 600px)': {
        flexGrow: '1'
      }
    },
    alias: {
      '@media screen and (max-width: 600px)': {
        fontSize: '12px'
      },
      color: gray100,
      fontSize: '14px'
    },
    basisActiveChip: {
      color: gray100
    },
    basisChip: {
      '.MuiChip-icon': {
        height: '16px',
        width: '16px'
      },
      bgcolor: gray10,
      borderRadius: '0px',
      height: '24px'
    },
    basisInactiveChip: {
      color: gray80
    },
    cardContent: {
      ':last-child': {
        p: 0
      },
      columnGap: '24px',
      display: 'flex',
      flexDirection: 'row',
      p: 0
    },
    category: {
      '@media screen and (max-width: 600px)': {
        fontSize: '12px'
      },
      color: gray90,
      fontSize: '14px'
    },
    co2Value: {
      color: primaryColor,
      fontSize: '26px',
      fontWeight: 700,
      lineHeight: '26px',
      mr: '4px',
      verticalAlign: 'bottom',
      '@media screen and (max-width: 600px)': {
        fontSize: '24px'
      }
    },
    co2ValueIcon: {
      color: primaryColor,
      height: '20px',
      width: '20px',
      verticalAlign: 'bottom'
    },
    co2ValueItem: {
      color: gray100,
      fontSize: '14px',
      fontWeight: 700,
      lineHeight: '14px',
      mr: '4px',
      verticalAlign: 'bottom'
    },
    co2ValueUnit: {
      color: gray100,
      fontSize: '14px',
      lineHeight: '14px',
      verticalAlign: 'bottom'
    },
    deleteButton: {
      boxSizing: 'border-box',
      height: '44px',
      p: '10px 22px 10px 16px',
      '@media screen and (max-width: 600px)': {
        display: 'none'
      }
    },
    deleteIcon: {
      color: gray90,
      display: 'none',
      fontSize: '32px',
      '&:hover': {
        opacity: '0.8'
      },
      '@media screen and (max-width: 600px)': {
        display: 'block'
      }
    },
    description: {
      color: gray90,
      fontSize: '12px'
    },
    editButton: {
      boxSizing: 'border-box',
      height: '44px',
      p: '10px 22px 10px 16px',
      '@media screen and (max-width: 600px)': {
        flexGrow: '1'
      }
    },
    firstImage: {
      '@media screen and (max-width: 1400px)': {
        maxWidth: favoriteWidth
      },
      '@media screen and (max-width: 1199px)': {
        maxWidth: '280px'
      },
      maxWidth: '280px',
      width: '100%'
    },
    guideMark: {
      color: gray90,
      cursor: 'pointer',
      height: '24px',
      width: '24px'
    },
    halfStar: {
      height: '24px',
      width: '24px',
      '@media screen and (max-width: 600px)': {
        height: '20px',
        width: '20px'
      }
    },
    myListNum: {
      alignItems: 'center',
      color: gray100,
      display: 'flex',
      fontSize: '14px',
      justifyContent: 'center',
      '@media screen and (max-width: 600px)': {
        fontSize: '12px'
      }
    },
    recommendChip: {
      '.MuiChip-label': {
        overflow: 'unset',
        p: 0
      },
      fontSize: '12px',
      fontWeight: 500,
      bgcolor: primary10,
      border: `1px solid ${primaryColor}`,
      borderRadius: '18px',
      color: primaryColor,
      height: '24px',
      p: '3px 10px',
      width: '68px'
    },
    reviewBox: {
      '@media screen and (max-width: 600px)': {
        mb: '8px'
      },
      bgcolor: gray10,
      borderRadius: '4px',
      display: 'flex',
      flexDirection: 'column',
      gap: '4px',
      mb: '24px',
      p: '12px'
    },
    reviewNull: {
      color: gray90,
      fontSize: '12px'
    },
    reviewText: {
      color: gray100,
      fontSize: '12px'
    },
    reviewTitle: {
      color: gray100,
      fontSize: '14px',
      fontWeight: 500
    },
    secondImage: {
      maxWidth: '135px'
    },
    statusBadge: {
      backgroundColor: badgeColor(),
      borderRadius: '50%',
      height: '12px',
      mr: '8px',
      width: '12px'
    },
    subTitle: {
      '@media screen and (max-width: 600px)': {
        fontSize: '14px'
      },
      color: gray100,
      fontWeight: 500,
      verticalAlign: 'middle'
    },
    tableCell: {
      boxSizing: 'border-box',
      padding: '8px 12px'
    },
    tableItem: {
      color: gray100,
      bgcolor: gray10,
      width: '130px'
    },
    tableValue: {
      color: gray100,
      fontSize: '14px'
    },
    textOverflow: {
      display: 'inline-block',
      ml: '8px',
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    },
    title: {
      '@media screen and (max-width: 600px)': {
        fontSize: '16px'
      },
      color: gray100,
      fontSize: '24px',
      fontWeight: 700
    },
    updateDate: {
      color: gray90,
      fontSize: '12px'
    },
    convValueChip: {
      bgcolor: primary10,
      color: primaryColor,
      fontSize: '12px',
      fontWeight: '500',
      height: '21px',
      mr: '8px'
    },
    calcValueChip: {
      bgcolor: green10,
      color: green100,
      fontSize: '12px',
      fontWeight: '500',
      height: '21px',
      mr: '8px'
    }
  };

  const [versionList, setVersionList] = useState<VersionType[]>([]);

  const dateFormatter = (date: Date, disitFlg?: boolean) => {
    const newDate = new Date(date);
    return newDate.toLocaleDateString('ja-JP', {
      year: 'numeric',
      month: disitFlg ? '2-digit' : 'long',
      day: disitFlg ? '2-digit' : 'numeric'
    });
  };

  const productInfosArray = (data: Array<{ id: number; createdAt: Date }>) => {
    const array: Array<VersionType> = [
      {
        id: 0,
        createdAt: '過去バージョン'
      }
    ];

    if (data.length > 0) {
      data.forEach((productInfo: { id: number; createdAt: Date }) => {
        array.push({
          id: productInfo.id,
          createdAt: dateFormatter(productInfo.createdAt, true)
        });
      });
    }

    return array;
  };

  useEffect(() => {
    if (!item.productInfos) return;
    setVersionList(
      item.productInfos.length > 0
        ? productInfosArray(item.productInfos)
        : [
            {
              id: 0,
              createdAt: '過去バージョン'
            }
          ]
    );
  }, [item]);

  const versionChange = (versionId: number, productInfoId?: number): void => {
    navigate(`/operator/material/${Number(item.productId)}`, {
      state: { productInfoId: productInfoId, oldVersion: versionId }
    });
  };

  // 評価の関数
  type StarProps = {
    type: 'filled' | 'half-filled' | 'outlined';
  };

  const Star = (props: StarProps) => {
    const { type } = props;
    switch (type) {
      case 'filled':
        return (
          <StarOutlinedIcon
            sx={{
              color: yellow,
              '@media screen and (max-width: 600px)': { width: '20px' }
            }}
          />
        );
      case 'half-filled':
        return (
          <CardMedia component="img" image={halfStar} sx={styles.halfStar} />
        );
      case 'outlined':
        return (
          <StarBorderOutlinedIcon
            sx={{
              color: gray80,
              '@media screen and (max-width: 600px)': { width: '20px' }
            }}
          />
        );
      default:
        return (
          <StarBorderOutlinedIcon
            sx={{
              color: gray80,
              '@media screen and (max-width: 600px)': { width: '20px' }
            }}
          />
        );
    }
  };

  const Rating = (props: { rating: number }) => {
    const { rating } = props;

    const starIcons = new Array(5).fill('outlined').map((_, index) => {
      if (rating - index >= 1) {
        return 'filled';
      } else if (rating - index >= 0.5) {
        return 'half-filled';
      }
      return 'outlined';
    });

    return (
      <Typography
        component="div"
        sx={{
          display: 'flex',
          mr: '4px',
          '@media screen and (max-width: 600px)': {
            height: '20px',
            alignItems: 'center'
          }
        }}
      >
        {starIcons.map((iconType, index) => (
          <Star type={iconType} key={index} />
        ))}
      </Typography>
    );
  };

  // ヘルプマークの表示
  const [dialogOpen, setDialogOpen] = React.useState(false);
  const handleDialogOpen = () => {
    setDialogOpen(!dialogOpen);

    window.dataLayer.push({
      event: 'click',
      screen: window.location.pathname,
      category: 'icon',
      action: window.location.pathname.split('/').pop() + '_help',
      user_id: userId,
      user_type: userType,
      user_rank: userRank
    });
  };

  const currentPagePath = window.location.pathname;
  const navigateToDetail = () => {
    if (adminPage) {
      navigate(`/operator/material/${item.productId}`, {
        state: { productInfoId: item.productInfoId }
      });
      return;
    } else if (currentPagePath.includes('product')) {
      navigate(`/material/${item.productId}`, {
        state: { productInfoId: item.productInfoId }
      });
      return;
    } else if (currentPagePath.includes('favorite')) {
      navigate(`/material/${item.productId}`);
      return;
    } else {
      window.open(`/material/${item.productId}`, '_blank');
      return;
    }
  };

  // 削除ダイアログの表示
  const [deleteDialogOpen, setDeleteDialogOpen] = useState<boolean>(false);

  // 表示するマイリスト追加数
  const [displayMyListNumber, setDisplayMyListNumber] = useState(
    item.myListNum
  );

  // ボタンセクション
  const ButtonSection = () => {
    let buttonSection;
    if (buttonSectionType === 'favorite') {
      // お気に入り一覧ページで使用
      const [displayMylistFlg, setDisplayMylistFlg] = useState<boolean>();

      useEffect(() => {
        setDisplayMylistFlg(item.myListFlg);
      }, [item.myListFlg]);

      buttonSection = (
        <>
          {displayMylistFlg ? (
            <Button
              startIcon={<AssignmentIcon sx={{ color: primaryColor }} />}
              sx={[tertiaryButtonOutlinedColor, styles.addButton]}
              variant="outlined"
              onClick={(e) => {
                e.stopPropagation();
                deleteMylistFun && deleteMylistFun(item.productId, item.name);
              }}
            >
              マイリストに追加済み
            </Button>
          ) : (
            <Button
              startIcon={<AssignmentOutlinedIcon sx={{ color: gray90 }} />}
              sx={[tertiaryButtonOutlinedColor, styles.addButton]}
              variant="outlined"
              onClick={(e) => {
                e.stopPropagation();
                addMylistFun && addMylistFun(item.productId, item.name);
              }}
            >
              マイリストに追加
            </Button>
          )}
          <Button
            onClick={(e) => {
              e.stopPropagation();
              deleteFavoriteFun && deleteFavoriteFun(item.productId, item.name);
            }}
            startIcon={<DeleteOutlineIcon sx={{ color: gray90 }} />}
            sx={[tertiaryButtonOutlinedColor, styles.deleteButton]}
            variant="outlined"
          >
            削除する
          </Button>
          <DeleteOutlineIcon
            onClick={(e) => {
              e.stopPropagation();
              deleteFavoriteFun && deleteFavoriteFun(item.productId, item.name);
            }}
            sx={styles.deleteIcon}
          />
        </>
      );
    } else if (buttonSectionType === 'registered') {
      if (
        item.status === productStatus.approved ||
        item.status === productStatus.draft ||
        item.status === productStatus.reject
      ) {
        buttonSection = (
          <>
            <Button
              onClick={(e) => {
                e.stopPropagation();
                navigate(`/product/edit/${item.productId}`, {
                  state: { productInfoId: item.productInfoId }
                });
              }}
              startIcon={<CreateOutlined sx={{ color: primaryColor }} />}
              sx={[primaryButtonOutlinedColor, styles.editButton]}
              variant="outlined"
            >
              編集する
            </Button>
            <Button
              onClick={(e) => {
                e.stopPropagation();
                setDeleteDialogOpen(true);
              }}
              startIcon={<DeleteOutline sx={{ color: gray90 }} />}
              sx={[tertiaryButtonOutlinedColor, styles.deleteButton]}
              variant="outlined"
            >
              削除する
            </Button>
            <DeleteOutline
              onClick={(e) => {
                e.stopPropagation();
                setDeleteDialogOpen(true);
              }}
              sx={styles.deleteIcon}
            />
          </>
        );
      } else {
        buttonSection = <></>;
      }
    } else if (buttonSectionType === 'adminRegistered') {
      buttonSection = (
        <>
          <Button
            onClick={(e) => {
              e.stopPropagation();
              navigate(`/operator/product/edit/${item.productId}`, {
                state: { productInfoId: item.productInfoId }
              });
            }}
            startIcon={<CreateOutlined sx={{ color: primaryColor }} />}
            sx={[primaryButtonOutlinedColor, styles.editButton]}
            variant="outlined"
          >
            編集する
          </Button>
          <Button
            onClick={(e) => {
              e.stopPropagation();
              setDeleteDialogOpen(true);
            }}
            startIcon={<DeleteOutline sx={{ color: gray90 }} />}
            sx={[tertiaryButtonOutlinedColor, styles.deleteButton]}
            variant="outlined"
          >
            削除する
          </Button>
          <DeleteOutline
            onClick={(e) => {
              e.stopPropagation();
              setDeleteDialogOpen(true);
            }}
            sx={styles.deleteIcon}
          />
        </>
      );
    } else if (buttonSectionType === 'materialsList') {
      // 建材検索ページで使用
      const [displayMylistFlg, setDisplayMylistFlg] = useState<boolean>();
      const [displayFavoriteFlg, setFavoriteFlg] = useState<boolean>();

      useEffect(() => {
        setDisplayMylistFlg(item.myListFlg);
        setFavoriteFlg(item.favoriteFlg);
      }, [item.myListFlg, item.favoriteFlg]);

      buttonSection = (
        <>
          {displayMylistFlg ? (
            <Button
              startIcon={<AssignmentIcon sx={{ color: primaryColor }} />}
              sx={[tertiaryButtonOutlinedColor, styles.addButton]}
              variant="outlined"
              onClick={(e) => {
                e.stopPropagation();
                deleteMylistFun && deleteMylistFun(item.productId, item.name);
              }}
            >
              マイリストに追加済み
            </Button>
          ) : (
            <Button
              startIcon={<AssignmentOutlinedIcon sx={{ color: gray90 }} />}
              sx={[tertiaryButtonOutlinedColor, styles.addButton]}
              variant="outlined"
              onClick={(e) => {
                e.stopPropagation();
                addMylistFun && addMylistFun(item.productId, item.name);
              }}
            >
              マイリストに追加
            </Button>
          )}

          {displayFavoriteFlg ? (
            <>
              <Button
                startIcon={<FavoriteOutlinedIcon sx={{ color: pink }} />}
                sx={[
                  tertiaryButtonOutlinedColor,
                  styles.addButton,
                  {
                    '@media screen and (max-width: 600px)': { display: 'none' }
                  }
                ]}
                variant="outlined"
                onClick={(e) => {
                  e.stopPropagation();
                  deleteFavoriteFun &&
                    deleteFavoriteFun(item.productId, item.name);
                }}
              >
                お気に入りに追加済み
              </Button>
              <IconButton
                onClick={(e) => {
                  e.stopPropagation();
                  deleteFavoriteFun &&
                    deleteFavoriteFun(item.productId, item.name);
                }}
                sx={{
                  '@media screen and (min-width:601px)': {
                    display: 'none'
                  }
                }}
              >
                <FavoriteOutlinedIcon
                  sx={{
                    color: pink,
                    height: '32px',
                    width: '32px'
                  }}
                />
              </IconButton>
            </>
          ) : (
            <>
              <Button
                startIcon={
                  <FavoriteBorderOutlinedIcon sx={{ color: gray90 }} />
                }
                sx={[
                  tertiaryButtonOutlinedColor,
                  styles.addButton,
                  {
                    '@media screen and (max-width: 600px)': { display: 'none' }
                  }
                ]}
                variant="outlined"
                onClick={(e) => {
                  e.stopPropagation();
                  addFavoriteFun && addFavoriteFun(item.productId, item.name);
                }}
              >
                お気に入りに追加
              </Button>
              <IconButton
                onClick={(e) => {
                  e.stopPropagation();
                  addFavoriteFun && addFavoriteFun(item.productId, item.name);
                }}
                sx={{
                  '@media screen and (min-width:601px)': {
                    display: 'none'
                  }
                }}
              >
                <FavoriteBorderOutlinedIcon
                  sx={{ height: '32px', width: '32px' }}
                />
              </IconButton>
            </>
          )}
        </>
      );
    }
    return buttonSection;
  };

  const shortenString = (str: string): string => {
    return str?.length > 30 ? str.slice(0, 30) + '...' : str;
  };

  const shortenString100 = (str: string): string => {
    return str?.length > 100 ? str.slice(0, 100) + '...' : str;
  };

  // 一時的に評価を非表示
  const showEvaluation: boolean = false;

  const ReviewBox = (): JSX.Element => {
    // 事務局の建材カードの場合
    if (adminFlg) {
      if (!item.title && !item.content) {
        return (
          <Box sx={styles.reviewBox}>
            <Grid container justifyContent={'space-between'}>
              <Typography sx={styles.reviewNull}>
                口コミはまだありません
              </Typography>
              {item.status === productStatus.approved && (
                <Button
                  onClick={(e) => {
                    e.stopPropagation();
                    navigate(`/operator/evaluation/${item.productId}`);
                  }}
                  startIcon={<CreateOutlined sx={{ color: primaryColor }} />}
                  sx={[primaryButtonOutlinedColor, styles.editButton]}
                  variant="outlined"
                >
                  口コミを追加する
                </Button>
              )}
            </Grid>
          </Box>
        );
      } else {
        return (
          <Box sx={styles.reviewBox}>
            <Typography sx={styles.reviewTitle}>{item.title}</Typography>
            <Typography sx={styles.reviewText}>{item.content}</Typography>
          </Box>
        );
      }
    }

    // 建材検索のカードの場合
    if (showEvaluation) {
      if (!item.title && !item.content) {
        return (
          <Box sx={styles.reviewBox}>
            <Grid container justifyContent={'space-between'}>
              <Typography sx={styles.reviewNull}>
                口コミはまだありません
              </Typography>
            </Grid>
          </Box>
        );
      } else {
        return (
          <Box sx={styles.reviewBox}>
            <Typography sx={styles.reviewTitle}>{item.title}</Typography>
            <Typography sx={styles.reviewText}>{item.content}</Typography>
          </Box>
        );
      }
    } else {
      return <></>;
    }
  };

  return (
    <>
      <Divider />
      <Card
        sx={{
          cursor: 'pointer',
          boxShadow: 'unset',
          color: 'unset',
          p: '24px 0',
          width: '100%'
        }}
        onClick={navigateToDetail}
      >
        <CardContent sx={styles.cardContent}>
          {/* left Image */}
          <Grid
            container
            alignContent={'flex-start'}
            rowGap={'10px'}
            sx={{
              maxWidth: '280px',
              '@media screen and (max-width: 1400px)': {
                maxWidth: favoriteWidth
              },
              '@media screen and (max-width: 1199px)': {
                maxWidth: '280px'
              },
              '@media screen and (max-width:850px)': {
                display: 'none'
              }
            }}
          >
            <CardMedia
              component="img"
              image={item?.images?.[0]?.filepath ?? noImage}
              sx={styles.firstImage}
            />
            <Grid container flexDirection={'row'} columnGap={'10px'}>
              {item?.images?.[1]?.filepath && (
                <CardMedia
                  component="img"
                  image={item?.images[1]?.filepath}
                  sx={styles.secondImage}
                />
              )}
              {item?.images?.[2]?.filepath && (
                <CardMedia
                  component="img"
                  image={item?.images[2]?.filepath}
                  sx={styles.secondImage}
                />
              )}
            </Grid>
            <Typography sx={styles.updateDate}>
              最終更新日 : {dayjs(item.updateDate).format('YYYY年MM月DD日')}
            </Typography>
          </Grid>

          {/* right information */}
          <Grid
            container
            flexDirection={'column'}
            justifyContent={'space-between'}
            sx={{
              maxWidth: 'calc(100% - 280px)',
              '@media screen and (max-width: 1400px)': {
                maxWidth: `calc(100% - ${favoriteWidth})`
              },
              '@media screen and (max-width: 1199px)': {
                maxWidth: 'calc(100% - 280px)'
              },
              '@media screen and (max-width:850px)': {
                maxWidth: '100%'
              }
            }}
          >
            <Grid item>
              <Grid
                container
                flexDirection={'row'}
                flexWrap={'nowrap'}
                columnGap={'8px'}
                mb={'12px'}
              >
                {/* sp image */}
                <CardMedia
                  component="img"
                  image={item?.images?.[0]?.filepath ?? noImage}
                  sx={[
                    styles.firstImage,
                    {
                      '@media screen and (max-width:850px)': {
                        display: 'block'
                      },
                      display: 'none',
                      width: '123px',
                      maxHeight: '123px'
                    }
                  ]}
                />
                <Grid width={'100%'}>
                  {/* status section */}
                  {statusSection && (
                    <Grid
                      container
                      flexDirection={'row'}
                      justifyContent={'space-between'}
                      flexWrap={'nowrap'}
                      sx={{
                        mb: '16px',
                        '@media screen and (max-width: 600px)': {
                          mb: '8px'
                        }
                      }}
                    >
                      <Grid item>
                        <Grid alignItems="center" container>
                          <Typography
                            component="span"
                            sx={[styles.statusBadge, statusBadgeBorder]}
                          ></Typography>
                          <Typography sx={{ fontBold: '500' }}>
                            {statusText()}
                          </Typography>
                        </Grid>
                      </Grid>
                      {adminPage && (
                        <Grid item>
                          <VersionSelect
                            list={versionList}
                            selectVersion={0}
                            versionChange={versionChange}
                            productInfoId={item.productInfoId}
                          />
                        </Grid>
                      )}
                    </Grid>
                  )}

                  {/* alias category section */}
                  <Grid
                    container
                    flexDirection={{ xs: 'column', sm: 'row' }}
                    justifyContent={'space-between'}
                    alignItems={{ xs: 'flex-start', sm: 'center' }}
                    mb={{ xs: '8px', sm: '4px' }}
                  >
                    <Typography sx={styles.alias}>
                      {shortenString(item.alias)}
                    </Typography>
                    <Typography sx={styles.category}>
                      {item.category ? item.category : ''}
                      {item.category && item.material ? ' / ' : ''}
                      {item.category && item.material
                        ? item.material.length > 12
                          ? item.material.slice(0, 12) + '...'
                          : item.material
                        : ''}
                    </Typography>
                  </Grid>

                  {/* title section */}
                  <Grid mb={'8px'}>
                    <Typography
                      sx={[
                        styles.title,
                        {
                          ':hover': { textDecoration: 'underline' },
                          width: '100%',
                          wordWrap: 'break-word'
                        }
                      ]}
                    >
                      {shortenString(item?.name)}
                      <Typography
                        component={'span'}
                        sx={[styles.subTitle, styles.textOverflow]}
                      >
                        {shortenString(item?.specification)}
                      </Typography>
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>

              {/* description section */}
              <Grid mb={{ xs: '8px', sm: '12px' }}>
                <Typography sx={styles.description}>
                  {shortenString100(item?.summary)}
                </Typography>
              </Grid>

              {/* co2 value section */}
              <Grid
                container
                flexDirection={'row'}
                flexWrap={'nowrap'}
                justifyContent={'space-between'}
                alignItems={'flex-end'}
                columnGap={'24px'}
                mb={'12px'}
              >
                <Grid
                  item
                  container
                  flexDirection={{ xs: 'column', sm: 'row' }}
                  columnGap={'4px'}
                  rowGap={'5px'}
                >
                  <Box>
                    <Typography component="span" sx={styles.co2ValueItem}>
                      CO2原単位
                    </Typography>
                    {item.calculatedMethod === 1 ? (
                      <Chip label="換算値" sx={[styles.convValueChip]} />
                    ) : item.calculatedMethod === 2 ? (
                      <Chip label="算定値" sx={[styles.calcValueChip]} />
                    ) : (
                      <></>
                    )}
                    <Typography component="span" sx={styles.co2Value}>
                      {item.calculatedEmissionIntensity !== null
                        ? item.calculatedEmissionIntensity
                        : 'ー'}
                    </Typography>
                    <Typography
                      component="span"
                      sx={[styles.co2ValueUnit, { mr: '24px' }]}
                    >
                      kg-CO2/{item.co2Unit}
                    </Typography>
                  </Box>
                  <Box>
                    <Typography component="span" sx={styles.co2ValueItem}>
                      CO2削減率
                    </Typography>
                    {item.calculatedReduceRate !== null &&
                    item.calculatedReduceRate !== undefined ? (
                      <>
                        <ChangeHistoryOutlinedIcon sx={styles.co2ValueIcon} />
                        <Typography component="span" sx={styles.co2Value}>
                          {item.calculatedReduceRate}
                        </Typography>
                      </>
                    ) : (
                      <Typography component="span" sx={styles.co2Value}>
                        ー
                      </Typography>
                    )}
                    <Typography component="span" sx={styles.co2ValueUnit}>
                      %
                    </Typography>
                  </Box>
                </Grid>
                <HelpOutlineOutlinedIcon
                  sx={styles.guideMark}
                  onClick={(e) => {
                    e.stopPropagation();
                    handleDialogOpen();
                  }}
                />
              </Grid>

              {/* table section */}
              <TableContainer sx={{ mb: '16px' }}>
                <Table>
                  <TableBody sx={{ border: `1px solid ${gray70}` }}>
                    <TableRow
                      sx={{
                        '&:last-child td, &:last-child th': { border: 0 }
                      }}
                    >
                      <TableCell
                        component="th"
                        scope="row"
                        sx={[styles.tableCell, styles.tableItem]}
                      >
                        メーカー算定値
                      </TableCell>
                      <TableCell
                        component="th"
                        scope="row"
                        sx={[styles.tableCell, styles.tableValue]}
                      >
                        {item.emissionIntensity !== null
                          ? item.emissionIntensity.toLocaleString() + ' '
                          : 'ー '}
                        kg-CO2/{item.co2Unit}
                      </TableCell>
                    </TableRow>
                    <TableRow
                      sx={{
                        '&:last-child td, &:last-child th': { border: 0 }
                      }}
                    >
                      <TableCell
                        component="th"
                        scope="row"
                        sx={[styles.tableCell, styles.tableItem]}
                      >
                        CO2算定根拠
                      </TableCell>
                      <TableCell
                        component="th"
                        scope="row"
                        sx={styles.tableCell}
                      >
                        <Grid
                          container
                          flexDirection={'row'}
                          gap={'8px'}
                          mb={'4px'}
                        >
                          <Chip
                            icon={
                              item.calculationBasisType.includes(1) ? (
                                <CheckOutlinedIcon />
                              ) : undefined
                            }
                            label="第三者認証"
                            sx={{
                              ...styles.basisChip,
                              ...(item.calculationBasisType.includes(1)
                                ? styles.basisActiveChip
                                : styles.basisInactiveChip)
                            }}
                          />
                          <Chip
                            icon={
                              item.calculationBasisType.includes(2) ? (
                                <CheckOutlinedIcon />
                              ) : undefined
                            }
                            label="自社算定"
                            sx={{
                              ...styles.basisChip,
                              ...(item.calculationBasisType.includes(2)
                                ? styles.basisActiveChip
                                : styles.basisInactiveChip)
                            }}
                          />
                          <Chip
                            icon={
                              item.calculationBasisType.includes(3) ? (
                                <CheckOutlinedIcon />
                              ) : undefined
                            }
                            label="その他"
                            sx={{
                              ...styles.basisChip,
                              ...(item.calculationBasisType.includes(3)
                                ? styles.basisActiveChip
                                : styles.basisInactiveChip)
                            }}
                          />
                        </Grid>
                        <Typography sx={styles.tableValue}>
                          {shortenString100(item.calculationBasisName)}
                        </Typography>
                      </TableCell>
                    </TableRow>
                    <TableRow
                      sx={{
                        '&:last-child td, &:last-child th': { border: 0 }
                      }}
                    >
                      <TableCell
                        component="th"
                        scope="row"
                        sx={[styles.tableCell, styles.tableItem]}
                      >
                        会社名
                      </TableCell>
                      <TableCell
                        component="th"
                        scope="row"
                        sx={[styles.tableCell, styles.tableValue]}
                      >
                        {item.company}
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>

              {mylistReviewSection && (
                <>
                  {/* mylist evaluation section */}
                  {/*  recommend Chip for SP */}
                  {item.recommendFlg[0] === checked && (
                    <Chip
                      label="おすすめ"
                      sx={[
                        styles.recommendChip,
                        {
                          '@media screen and (max-width:600px)': {
                            display: 'block',
                            mb: '5px'
                          },
                          display: 'none'
                        }
                      ]}
                    />
                  )}

                  <Grid
                    container
                    flexDirection={'row'}
                    justifyContent={'flex-start'}
                    alignItems={'center'}
                    flexWrap={'nowrap'}
                    columnGap={'12px'}
                    mb={'8px'}
                  >
                    <Typography sx={styles.myListNum}>
                      マイリスト追加数：{displayMyListNumber}
                    </Typography>
                    <Divider orientation="vertical" sx={{ height: '24px' }} />
                    <Typography component="div" sx={styles.myListNum}>
                      評価：
                      <Rating rating={item.score} />
                      {item.score}
                    </Typography>

                    {/*  recommend Chip for PC */}
                    {item.recommendFlg[0] === checked && (
                      <Chip
                        label="おすすめ"
                        sx={[
                          styles.recommendChip,
                          {
                            '@media screen and (max-width:600px)': {
                              display: 'none'
                            }
                          }
                        ]}
                      />
                    )}
                  </Grid>

                  {/* review section */}
                  <ReviewBox />
                </>
              )}

              <Typography
                sx={[
                  styles.updateDate,
                  {
                    '@media screen and (max-width:600px)': {
                      display: 'block'
                    },
                    display: 'none',
                    mb: '16px'
                  }
                ]}
              >
                最終更新日 : {dayjs(item.updateDate).format('YYYY年MM月DD日')}
              </Typography>
            </Grid>

            {/* button section */}
            <Grid
              container
              flexDirection={'row'}
              justifyContent={'flex-end'}
              alignItems={'center'}
              gap={{ xs: '16px', sm: '16px' }}
              sx={{ alignSelf: 'flex-start', mt: '8px' }}
            >
              {buttonSection && buttonSection}
              {ButtonSection()}
            </Grid>
          </Grid>
        </CardContent>
      </Card>
      <CustomDialog
        onClose={(e) => {
          e.stopPropagation();
          handleDialogOpen();
        }}
        open={dialogOpen}
      />
      <DeleteDialog
        open={deleteDialogOpen}
        setDialogOpen={setDeleteDialogOpen}
        onDelete={() => deleteProductFun && deleteProductFun(item.productId)}
        title={'建材を削除'}
      />
    </>
  );
};

export default MaterialCard;
